import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NavService} from './nav-service';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';

@Injectable({
  providedIn: 'root',
})
export class EntitesNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  edition = this.makeNavigator(EparcoursPath.root.ENTITES, EparcoursPath.entites.EDITION);

  edition_by_id = this.makeNavigatorWithParam<number>(EparcoursPath.root.ENTITES, EparcoursPath.entites.EDITION);

  creation = this.makeNavigator(EparcoursPath.root.ENTITES, EparcoursPath.entites.CREATION);
}
